// ABOUTME: class-variance-authority variants of CBadge
// ABOUTME: Kept apart from the component so CBadge.tsx exports only the component

import { cva } from "class-variance-authority"

export const badgeVariants = cva(
  "inline-flex items-center rounded-md border font-semibold whitespace-nowrap transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
)
